export const methods = [
	{ label: 'Хочу заработать', value: 'earn' },
	{ label: 'Хочу потратить', value: 'spend' },
]
